import { Component } from 'react'
import PropTypes from 'prop-types'
import { hasSegmentSnippet, installSegment } from '@driftt/traffic-control'

class DriftWidget extends Component {

  static propTypes = {
    embedId: PropTypes.string.isRequired
  }

  componentDidMount() {
    if (!hasSegmentSnippet()) {
      installSegment()
    }
  }

  render() {
    return null
  }
}

export default DriftWidget
